import { useQuery } from "@tanstack/react-query";
import alertService from "../services/alert.service";

export const useShortList = () => {
  const {
    isLoading,
    data: shortList,
    error,
  } = useQuery({
    queryKey: ["shortList"],
    queryFn: () => alertService.getShortList(),
  });

  return { isLoading, shortList, error };
};
